import { useState } from 'react';
import ScenarioConsultationDrawer from './ScenarioConsultationDrawer';

const bizTypes = [
  {
    code: '9810',
    name: '跨境电商',
    icon: 'ri-shopping-cart-2-line',
    desc: '平台申报 · 收款核验 · 发票归集',
    color: 'from-teal-500 to-cyan-500',
    bg: 'bg-teal-50',
    border: 'border-teal-200',
    text: 'text-teal-700',
  },
  {
    code: '0110',
    name: '外贸公司',
    icon: 'ri-building-2-line',
    desc: '报关单证 · 退税链路 · 合规留痕',
    color: 'from-orange-400 to-amber-400',
    bg: 'bg-orange-50',
    border: 'border-orange-200',
    text: 'text-orange-700',
  },
  {
    code: '1039',
    name: '市场商户',
    icon: 'ri-store-2-line',
    desc: '市场采购 · 汇总申报 · 核销管理',
    color: 'from-emerald-500 to-green-500',
    bg: 'bg-emerald-50',
    border: 'border-emerald-200',
    text: 'text-emerald-700',
  },
];

const complianceTags = [
  { icon: 'ri-file-text-line', label: '单证归档' },
  { icon: 'ri-shield-check-line', label: '规则校验' },
  { icon: 'ri-links-line', label: '核销链路' },
  { icon: 'ri-search-eye-line', label: '可追溯' },
  { icon: 'ri-global-line', label: '海关直连' },
  { icon: 'ri-money-cny-circle-line', label: '退税管理' },
];

export default function ScenariosHero() {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [activeCard, setActiveCard] = useState(0);

  const handleGetSolution = () => {
    setIsDrawerOpen(true);
  };

  const handleViewPricing = () => {
    window.REACT_APP_NAVIGATE('/capabilities');
  };

  const handleTryFirst = () => {
    window.REACT_APP_NAVIGATE('/capabilities');
    setTimeout(() => {
      const aClassSection = document.querySelector('[data-tab="a-class"]');
      if (aClassSection) {
        aClassSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 100);
  };

  return (
    <>
      <section className="relative min-h-screen flex items-center pt-[72px] overflow-hidden">
        {/* Background Image */}
        <div className="absolute inset-0 w-full h-full">
          <img
            src="https://public.readdy.ai/ai/img_res/97855cf8af98e4fcb27e4ce06591654a.jpg"
            alt="场景方案背景"
            className="w-full h-full object-cover object-top"
          />
          {/* 统一双层遮罩结构 */}
          <div className="absolute inset-0 bg-gradient-to-br from-white/65 via-white/40 to-teal-50/50"></div>
          <div className="absolute inset-0 bg-gradient-to-r from-white/80 via-white/40 to-transparent"></div>
        </div>

        <div className="relative z-10 max-w-[1400px] mx-auto px-6 py-20 w-full">
          <div className="grid lg:grid-cols-2 gap-16 items-center">
            {/* Left Content */}
            <div className="space-y-8">
              {/* 统一顶部标签徽章样式 */}
              <div className="inline-flex items-center gap-2 px-4 py-1.5 bg-teal-50 border border-teal-200 rounded-full text-teal-700 text-sm font-medium">
                <i className="ri-map-pin-2-line text-base"></i>
                按业务形态精准匹配
              </div>

              {/* 统一主标题样式 */}
              <h1 className="text-5xl lg:text-6xl font-extrabold leading-tight">
                <span className="bg-gradient-to-r from-[#0D9488] to-[#14B8A6] bg-clip-text text-transparent">
                  不同业务形态
                </span>
                <br />
                <span className="text-gray-800">
                  对应专属合规方案
                </span>
              </h1>

              {/* 统一正文样式 */}
              <div className="space-y-3">
                <p className="text-lg text-gray-700 leading-relaxed">
                  跨境电商（9810）、外贸公司（0110）、市场商户（1039），
                </p>
                <p className="text-lg text-gray-500 leading-relaxed">
                  不同模式对应不同管理挑战，精准匹配合规方案组合。
                </p>
              </div>

              {/* Compliance Tags - 统一样式 */}
              <div className="flex flex-wrap gap-2">
                {complianceTags.map((tag) => (
                  <span
                    key={tag.label}
                    className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-white/80 border border-gray-200 rounded-full text-gray-600 text-sm shadow-sm"
                  >
                    <i className={`${tag.icon} text-teal-500`}></i>
                    {tag.label}
                  </span>
                ))}
              </div>

              {/* 统一按钮组样式 */}
              <div className="space-y-3 max-w-md pt-2">
                {/* 主按钮：橙色渐变 rounded-full h-14 shadow-lg hover:scale-105 */}
                <button
                  onClick={handleGetSolution}
                  className="w-full h-14 bg-gradient-to-r from-[#FF6B35] to-[#FF8C42] text-white font-medium rounded-full hover:scale-105 transition-transform flex items-center justify-center gap-2 whitespace-nowrap cursor-pointer shadow-lg"
                >
                  获取定制方案
                  <i className="ri-arrow-right-line"></i>
                </button>

                {/* 次按钮：bg-white/70 backdrop-blur-sm border-2 border-[#14B8A6] rounded-full h-14 */}
                <button
                  onClick={handleViewPricing}
                  className="w-full h-14 bg-white/70 backdrop-blur-sm border-2 border-[#14B8A6] text-[#0D9488] font-medium rounded-full hover:bg-[#14B8A6] hover:text-white transition-all whitespace-nowrap cursor-pointer"
                >
                  查看产品及价格
                </button>

                {/* 文字链接按钮：text-[#0D9488] text-sm h-12 带右上角箭头图标 */}
                <button
                  onClick={handleTryFirst}
                  className="w-full h-12 text-[#0D9488] text-sm font-medium hover:underline transition-all whitespace-nowrap cursor-pointer flex items-center justify-center gap-1"
                >
                  先跑通一票（9.9/99）
                  <i className="ri-arrow-right-up-line text-base"></i>
                </button>
              </div>
            </div>

            {/* Right Visual - Biz Type Cards */}
            <div className="relative flex flex-col gap-5 justify-center">
              {bizTypes.map((biz, index) => (
                <div
                  key={biz.code}
                  onMouseEnter={() => setActiveCard(index)}
                  className={`relative rounded-2xl border-2 p-5 cursor-pointer transition-all duration-400 backdrop-blur-sm ${
                    activeCard === index
                      ? `${biz.bg} ${biz.border} shadow-xl scale-[1.03]`
                      : 'bg-white/80 border-gray-200 shadow-sm hover:shadow-md'
                  }`}
                >
                  <div className="flex items-center gap-4">
                    {/* Icon */}
                    <div className={`w-14 h-14 flex items-center justify-center rounded-xl bg-gradient-to-br ${biz.color} shadow-md flex-shrink-0`}>
                      <i className={`${biz.icon} text-2xl text-white`}></i>
                    </div>

                    {/* Info */}
                    <div className="flex-1 min-w-0">
                      <div className="flex items-center gap-2 mb-1">
                        <span className={`text-lg font-bold ${activeCard === index ? biz.text : 'text-gray-800'}`}>
                          {biz.name}
                        </span>
                        <span className={`text-xs px-2 py-0.5 rounded-full font-mono font-semibold ${
                          activeCard === index ? `${biz.bg} ${biz.text} border ${biz.border}` : 'bg-gray-100 text-gray-500'
                        }`}>
                          {biz.code}
                        </span>
                      </div>
                      <p className={`text-sm ${activeCard === index ? biz.text : 'text-gray-500'}`}>
                        {biz.desc}
                      </p>
                    </div>

                    {/* Arrow */}
                    <div className={`w-8 h-8 flex items-center justify-center rounded-full transition-all duration-300 flex-shrink-0 ${
                      activeCard === index ? `bg-gradient-to-br ${biz.color}` : 'bg-gray-100'
                    }`}>
                      <i className={`ri-arrow-right-line text-sm ${activeCard === index ? 'text-white' : 'text-gray-400'}`}></i>
                    </div>
                  </div>

                  {/* Expanded detail */}
                  {activeCard === index && (
                    <div className={`mt-4 pt-4 border-t ${biz.border} grid grid-cols-3 gap-3`}>
                      {['申报合规', '单证管理', '链路追溯'].map((item) => (
                        <div key={item} className={`flex items-center gap-1.5 text-xs font-medium ${biz.text}`}>
                          <i className="ri-check-line text-sm"></i>
                          {item}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              ))}

              {/* Bottom hint */}
              <p className="text-center text-xs text-gray-400 mt-2">
                悬停卡片查看对应方案要点
              </p>
            </div>
          </div>
        </div>
      </section>

      <ScenarioConsultationDrawer
        isOpen={isDrawerOpen}
        onClose={() => setIsDrawerOpen(false)}
      />
    </>
  );
}